import { Tag } from "lucide-react";

/**
 * Pill mostrato al posto del prezzo formattato quando il prodotto non ha
 * ancora un prezzo di vendita (price=0/null E price_per_kg=0/null).
 * Cliccabile: invoca `onClick` che nel caller apre il ProductSheet in modifica.
 * Stile coerente con gli altri badge dell'app (F4F1ED + EAE7E1, testo verde-scuro).
 */
export default function SetPricePill({ product, onClick, size = "sm" }) {
  const base = size === "xs" ? "text-[10px] px-1.5 py-0.5 gap-1" : "text-xs px-2 py-0.5 gap-1";
  return (
    <button
      type="button"
      data-testid={`set-price-pill-${product?.id}`}
      onClick={onClick}
      title="Imposta il prezzo di vendita di questo prodotto"
      className={`inline-flex items-center font-semibold rounded-md border border-[#EAE7E1] bg-[#F4F1ED] text-[#5C5F5A] hover:bg-[#E8F3EC] hover:text-[#2B5A3F] hover:border-[#C5E1D1] transition-colors ${base}`}
    >
      <Tag size={size === "xs" ? 9 : 11} />
      Imposta prezzo
    </button>
  );
}
